import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { VxEmptyStateComponent } from '@ui/empty-state/empty-state.component';
import { VxItemCellComponent } from '@ui/item-cell/item-cell.component';
import { VxListRowComponent } from '@ui/list-row/list-row.component';
import { VxPanelComponent } from '@ui/panel/panel.component';
import { VxSkeletonComponent } from '@ui/skeleton/skeleton.component';
import { SharedModule } from 'src/app/core/shared.module';
import { AlertStatusLabelComponent } from 'src/app/pages/internal/alerts/components/alert-status-label/alert-status-label.component';
import { AlertsState } from 'src/app/store/alerts/alerts.state';

/** The correlation groups of the last processor simulation, straight from the store. */
@Component({
  selector: 'app-alert-processor-simulation-result-viewer',
  templateUrl: './result-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SharedModule,
    AlertStatusLabelComponent,
    VxEmptyStateComponent,
    VxItemCellComponent,
    VxListRowComponent,
    VxPanelComponent,
    VxSkeletonComponent,
  ],
  host: { class: 'block' },
})
export class AlertProcessorSimulationResultViewerComponent {
  private store = inject(Store);

  private response = this.store.selectSignal(
    AlertsState.alertProcessorSimulationResponse
  );

  protected isLoading = computed(() => this.response().isLoading === true);

  protected groups = computed(
    () => this.response().data?.correlationResults ?? []
  );
}
